import { Link } from "react-router-dom";

type RouteLink = { to: string; label: string };
type HrefLink = { href: string; label: string };
type FooterLink = RouteLink | HrefLink;

const footerLinks: Record<string, FooterLink[]> = {
  Product: [
    { to: "/features", label: "Features" },
    { to: "/pricing", label: "Pricing" },
    { to: "/portal/login", label: "Download" },
  ],
  Support: [
    { to: "/help", label: "Help centre" },
    { to: "/help/guides", label: "Guides" },
    { to: "/help/faq", label: "FAQ" },
    { href: "mailto:support@bookburrow.uk", label: "Contact us" },
  ],
  Company: [
    { to: "/privacy", label: "Privacy" },
    { to: "/terms", label: "Terms" },
  ],
};

export function Footer() {
  return (
    <footer className="site-footer relative bg-forest-950 text-cream-200">
      {/* Decorative top border */}
      <div className="h-px bg-gold-300/40" />

      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4 md:gap-12">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-1">
            <img src="/logo-light.svg" alt="Bookburrow" className="h-8" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-cream-200/90">
              The beautifully simple library system for UK schools.
              Built with care by Roguelite Software.
            </p>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([heading, links]) => (
            <div key={heading}>
              <h3 className="text-xs font-semibold uppercase tracking-widest text-gold-200">
                {heading}
              </h3>
              <ul className="mt-4 space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    {"href" in link ? (
                      <a
                        href={link.href}
                        className="text-sm text-cream-200/90 transition-colors hover:text-gold-400"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.to}
                        className="text-sm text-cream-200/90 transition-colors hover:text-gold-400"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-cream-200/10 pt-8 sm:flex-row">
          <p className="text-xs text-cream-200/75">
            &copy; {new Date().getFullYear()} Roguelite Software Ltd. Registered in England and Wales,
            company number 17052264. Registered office: Belmont Suite Paragon Business Park,
            Chorley New Road, Bolton, Lancashire, England, BL6 6HG.
          </p>
          <p className="flex shrink-0 items-center gap-2 whitespace-nowrap text-xs text-cream-200/75">
            {/* Public-domain flag by SpinnerLaserz, Wikimedia Commons; recoloured in forest and cream.
                https://commons.wikimedia.org/wiki/File:Flag_of_the_United_Kingdom_(black_and_white;_variant_1).svg */}
            <img
              src="/uk-flag-monochrome.svg"
              alt=""
              width={28}
              height={14}
              className="h-3.5 w-7 rounded-sm opacity-75"
            />
            Built and hosted in the UK
          </p>
        </div>
      </div>
    </footer>
  );
}
